export enum SmartPHState {
    IDLE = 0,
    CHECK_CONDITIONS = 1,
    PRIMING = 2,
    PREAMBLE_PULSE = 3,
    DOSING = 4,
    WAIT_BETWEEN_SHOTS = 5,
    EVALUATE_RECOVERY = 6,
    ERROR_RECOVERY = 7,
    POST_PREAMBLE_WAIT = 8,
    ABORT_SEQUENCE = 9,
}

export const SmartPHStateTextMap: Record<SmartPHState, string> = {
    [SmartPHState.IDLE]: 'Idle',
    [SmartPHState.CHECK_CONDITIONS]: 'Check Conditions',
    [SmartPHState.PRIMING]: 'Priming',
    [SmartPHState.PREAMBLE_PULSE]: 'Preamble Pulse',
    [SmartPHState.DOSING]: 'Dosing',
    [SmartPHState.WAIT_BETWEEN_SHOTS]: 'Wait Between Shots',
    [SmartPHState.EVALUATE_RECOVERY]: 'Evaluate Recovery',
    [SmartPHState.ERROR_RECOVERY]: 'Error Recovery',
    [SmartPHState.POST_PREAMBLE_WAIT]: 'Post Preamble Wait',
    [SmartPHState.ABORT_SEQUENCE]: 'Abort Sequence',
};